import React, { useEffect, useState } from 'react';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import LogoutButton from '@/components/LogoutButton';
import { selectUser } from '@/features/user/selectors';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { Error4xxPage } from '@bypasslane/clover--web-lib-sprout-error-4xx-page';
import { Error5xxPage } from '@bypasslane/clover--web-lib-sprout-error-5xx-page';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const NotFound = () => (
  <div className="flex flex-row items-center justify-center w-full h-full">
    <Error4xxPage
      className="test"
      footerClassName="test-footer"
      headingId="error-4xx-page"
      headingLevel="h1"
      title="We couldn’t find that page"
      footerChildren={
        <Action variant="secondary" to="/">
          Go to Home
        </Action>
      }
    >
      <p>Check the website address or explore other pages.</p>
    </Error4xxPage>
  </div>
);

export const Error = ({ isFallback = false }) => {
  const [showError, setShowError] = useState(!isFallback);
  const user = useSelector(selectUser);

  useEffect(() => {
    if (isFallback) {
      const timer = setTimeout(() => setShowError(true), 10_000);
      return () => clearTimeout(timer);
    }
  }, [isFallback]);

  if (!showError) {
    return <LoadingSpinner />;
  }

  return (
    <div className="flex flex-row items-center justify-center w-full h-full">
      <Error5xxPage
        className="test"
        footerChildren={
          <>
            {user ? (
              <LogoutButton />
            ) : (
              <Action variant="secondary" to="/">
                Try Again
              </Action>
            )}
          </>
        }
        footerClassName="test"
        title="Something went wrong"
      >
        <p>
          We’re unable to load this page. Try reloading or{' '}
          <a href="https://www.clover.com/en-US/help">contact support</a> if the issue continues.
        </p>
      </Error5xxPage>
    </div>
  );
};

// export default withAuthLayout(Error, { enableProfiler: true });
export default Error;

Error.propTypes = {
  error: PropTypes.string,
  errorCode: PropTypes.number,
  isFallback: PropTypes.bool
};
Error.displayName = 'ErrorPage';
